import { render } from "./secured-by-flutterwave.vue?vue&type=template&id=5b565c6a&scoped=true"
import script from "./secured-by-flutterwave.vue?vue&type=script&lang=js"
export * from "./secured-by-flutterwave.vue?vue&type=script&lang=js"

import "./secured-by-flutterwave.vue?vue&type=style&index=0&id=5b565c6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b565c6a"]])

export default __exports__